import { translationConstants } from "../constants";
import SpinnerContainer from "../shared/components/Spinner/SpinnerContainer";

export const getCenterInvitationStatusOptions = (t) => {
  return [
    { id: 1, value: "Approved", label: t(translationConstants.APPROVED) },
    { id: 2, value: "Rejected", label: t(translationConstants.REJECTED) },
    { id: 3, value: "Pending", label: t(translationConstants.PENDING_CENTER) },
    { id: 4, value: "Removed", label: t(translationConstants.REMOVED) },
  ];
};

export const updateObject = (oldObject, updatedProperties) => ({
  ...oldObject,
  ...updatedProperties,
});

//-------Loading Indicator for Infinity Scroll
export const loadingIndicator = (t) => {
  return (
    <div className="w-100 d-flex text-black font-16 justify-content-center align-items-center p-4">
      <span>{t(translationConstants.LOADING)}</span>
    </div>
  );
};

//-------Data End Message for Infinity Scroll
export const dataEndMessage = (t, data) => {
  return (
    <div className="w-100 d-flex text-black font-16 justify-content-center align-items-center p-4 ">
      <span>
        {data?.length > 0
          ? t(translationConstants.NO_MORE_DATA_FOUND)
          : t(translationConstants.noDataFound)}
      </span>
    </div>
  );
};
